/* eslint-disable @typescript-eslint/no-unused-vars */
import { cn } from "@/lib/utils";
import { useMemo } from "react";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const AuditTableV4 = ({ data }: any) => {
  const header = useMemo(() => {
    if (!data) {
      return [];
    }
    try {
      return data[0] && Object.keys(data[0]);
    } catch (_error) {
      return [];
    }
    return [];
  }, [data]);
  console.log({ header });
  return (
    <>
      {data?.length === 0 ? null : (
        <table className="w-full">
          {data?.map((row: any, rowIndex: number) => {
            const newData: any = Object.keys(row);
            const newData2: any = Object.values(row);
            return (
              <tr
                key={rowIndex}
                className={cn(
                  rowIndex === 0 ? "border-t border-b" : "border-b"
                )}
              >
                <td className="py-3 text-[#94a3b8] text-[14px] pl-0 pr-4 text-left sm:break-words break-anywhere w-[150px] h-auto">
                  {newData?.[0]}
                </td>
                <td
                  className={cn(
                    "relative flex text-[14px] items-center flex-grow  text-slate-600 text-left sm:break-words break-anywhere  h-auto py-3 pl-0",
                    newData2?.[0]?.feedback
                      ? "bg-green-50 border border-green-100"
                      : ""
                  )}
                >
                  : {newData2?.[0]?.text}
                </td>
              </tr>
            );
          })}
        </table>
      )}
    </>
  );
};
